import "./index.scss";
import React, { useState } from "react";

export default function InputSearch({
  disabled,
  handleChange,
  handleSearch,
  icon,
  label,
  placeholder,
  results,
  toggleModal,
  value,
}) {
  const [showResults, setShowResults] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [isTyping, setIsTyping] = useState(false);

  const display =
    value && value.company ? value.company + " - " + value.name : value;

  // Show the user's input when typing, otherwise show the formatted display
  const displayValue = isTyping ? inputValue : display || "";

  return (
    <div className="md-diy-input-wrapper">
      <img src={icon} className="md-diy-input-icon" alt="" />
      <input
        disabled={disabled || false}
        type="text"
        placeholder={placeholder}
        onChange={(e) => {
          const newValue = e.target.value;
          setInputValue(newValue);
          setIsTyping(true);
          handleSearch(label, newValue);
        }}
        onFocus={() => {
          setShowResults(true);
          setIsTyping(true);
          setInputValue(display || ""); // Start with current display value
        }}
        onBlur={() => {
          setShowResults(false);
          setIsTyping(false);
          setInputValue(""); // Reset input value when not typing
        }}
        value={displayValue}
      />
      <div className={showResults ? "md-diy-search-results" : "d-none"}>
        {results.map((result) => {
          let resultDisplay = "";
          if (result.company && result.name) {
            resultDisplay = result.company + " - " + result.name;
          } else if (!result.company && result.name) {
            resultDisplay = result.name;
          } else if (!result.company && !result.name) {
            resultDisplay = result;
          }

          return (
            <p
              key={result.id}
              onMouseDown={(e) => {
                e.preventDefault();
                handleChange(label, result);
                setShowResults(false);
                setIsTyping(false);
                setInputValue("");
              }}
            >
              {resultDisplay}
            </p>
          );
        })}
        <div className="md-diy-search-results-footer">
          <a
            href="/"
            onClick={(e) => e.preventDefault()}
            onMouseDown={(e) => toggleModal(e, label)}
          >
            + Add New
          </a>
        </div>
      </div>
    </div>
  );
}
